import { Moment } from "moment";
import ConfirmModal from "PFComponents/confirm/confirm_modal";
import { useSplitBooking } from "PFCore/hooks/queries/bookings/split_booking/use_split_booking";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";
import { useTranslation } from "react-i18next";

import { useBookingBarContext } from "../../booking_bar_provider";
import css from "./split_booking_modal.module.scss";
import { SplitBookingVisualisation } from "./split_booking_visualisation";
import { useSuccessErrorHandlers } from "./use_success_error_handlers";

interface SplitBookingModalProps {
  splitDate: Moment;
  onClose: () => void;
}

export const SplitBookingModal = ({ splitDate, onClose }: SplitBookingModalProps): JSX.Element => {
  const { booking } = useBookingBarContext();
  const { start_date: startDate, end_date: endDate } = booking || {};
  const { t } = useTranslation("bookingModule");
  const { utc, formatISODate } = useDateFormatter();
  const { onSuccess, onError } = useSuccessErrorHandlers();
  const { mutate: splitBooking, isLoading } = useSplitBooking({ onSuccess, onError });

  const handleOK = () => {
    const newBookingStartDate = formatISODate(utc(splitDate).add(1, "day"));
    booking && splitBooking({ bookingId: booking.id, splitDate: newBookingStartDate });
  };

  return (
    <ConfirmModal
      handleOK={isLoading ? undefined : handleOK}
      handleClose={onClose}
      executeCloseOnOk={false}
      title={t("splitMode.confirmModal.title")}
      labelOK={t("splitMode.confirmModal.confirm")}
      classes={{
        dialog: css.modalDialog,
        title: css.modalTitle
      }}
    >
      <div className={css.modalText}>{t("splitMode.confirmModal.description")}</div>
      <SplitBookingVisualisation startDate={utc(startDate)} endDate={utc(endDate)} splitDate={splitDate} />
      <div className={css.modalText}>{t("splitMode.confirmModal.warning")}</div>
    </ConfirmModal>
  );
};
